import { defineStore } from 'pinia'
import api from '@/plugins/axios'

export const useConversationsStore = defineStore('conversations', {
  state: () => ({
    conversations: [],
    supportedLanguages: [
      'English',
      'French',
      'Italian',
      'Spanish',
      'German',
      'Japanese',
      'Korean',
      'Chinese',
      'Arabic',
      'Russian',
      'Portuguese',
      'Swedish',
      'Greek'
    ],
    supportedScenarios: [
      'At the restaurant',
      'At the hotel',
      'At the airport',
      'Shopping',
      'Asking for directions',
      'Emergency'
    ],
    supportedDifficulties: ['Easy', 'Medium', 'Hard'],
    showCreditsModal: false
  }),
  actions: {
    async fetchConversations () {
      try {
        const response = await api.get('/conversation')
        this.conversations = response.data
      } catch (error) {
        console.error('Error fetching conversations:', error)
      }
    },
    async postConversation (language, scenario, difficulty) {
      try {
        const messages = []
        const conversation = {
          scenario,
          language: language.toLowerCase(),
          difficulty: difficulty.toLowerCase(),
          messages
        }
        const response = await api.post('/conversation', conversation)
        this.conversations.unshift(response.data)
        return response.data
      } catch (error) {
        console.error('Error posting conversation:', error)

        // Handle 403 error to trigger the modal
        if (error.response && error.response.status === 403) {
          this.showCreditsModal = true
        }
        throw error
      }
    },
    async deleteConversation (conversationId) {
      try {
        await api.delete(`/conversation/${conversationId}`)
        this.conversations = this.conversations.filter(
          (conversation) => conversation.conversation_id !== conversationId
        )
      } catch (error) {
        console.error('Error deleting conversation:', error)
      }
    }
  }
})
